export enum StorefrontWidgetCheckoutSpacing {
  None = "none",
  PaddingAbove = "padding_above",
  PaddingBelow = "padding_below",
  PaddingBoth = "padding_both",
  DividerAbove = "divider_above",
  DividerBelow = "divider_below",
  DividerBoth = "divider_both",
}
